<template>
  <div v-if="person.id" class="rate--wrap">

    <RateButton/>

    <div v-if="refs.results && refs.results[slide]" :class="`rate--image rate--image-${voteBusy || imageLoaded ? 'busy' : ''}`">
      <swiper :options="swiperOption" :not-next-tick="notNextTick" ref="mySwiper">
        <swiper-slide>
          <img :src="imageLoaded ? null : refs.results[slide].image"/>
        </swiper-slide>
      </swiper>
      <div class="hidden" :data="waitNewImage()" v-if="voteBusy"/>
    </div>
    

    <RateButton :direction="true"/>

    <RateIndicator/>

    <div :class="['rate--hint', {'rate--hint-active': hint}]">
      <p>Голосовать можно стрелками на клавиатуре&nbsp;↔ </p>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';
import RateIndicator from '@/components/Rate/Indicator';
import RateButton from '@/components/Rate/Button';

export default {
  name: 'Rate',
  components: {
    RateIndicator,
    RateButton,
  },

  computed: mapGetters({
    voteCounter: 'voteCounter',
    voteBusy: 'voteBusy',
    person: 'personCurrent',
    tempRefs: 'tempRefs',
    slide: 'slide',
    refs: 'refs',
  }),

  data() {
    return {
      imageLoaded: false,
      storeRefs: [],
      rateScale: {
        down: 1,
        up: 1,
      },
      hint: false,
      notNextTick: true,
      swiperOption: {
        direction: 'horizontal',
        grabCursor: true,
        setWrapperSize: false,
        autoHeight: false,
        pagination: '.swiper-pagination',
        paginationClickable: false,
        mousewheelControl: false,
        observeParents: false,
        onTouchEnd: (swiper) => {
          if (Math.abs(swiper.touches.currentX - swiper.touches.startX) > window.innerWidth / 6) {
            const dir = swiper.touches.currentX > swiper.touches.startX;
            const val = dir ? 500 : 100;
            this.voteFor(val);
          }
        },
      },
    };
  },

  mounted() {
    document.body.addEventListener('keyup', this.keyListener);
    document.body.className = 'overflow-y';
    if (this.$route.params.slug) {
      setTimeout(() => {
        this.$store.dispatch('fetchNewRefs', { slug: this.$route.params.slug, person: this.person });
      }, 400);
    }
  },

  beforeDestroy() {
    document.body.removeEventListener('keyup', this.keyListener);
    document.body.className = '';
  },

  watch: {
    voteCounter() {
      if (!this.$cookie.get('hinted') && this.voteCounter > 3) {
        this.$cookie.set('hinted', 'true', 9999999);
        this.showHint();
      }
    },
  },

  methods: {
    updateScale(swiper) {
      const dir = swiper.touches.currentX > swiper.touches.startX ? 'up' : 'down';
      const delta = Math.abs(swiper.touches.currentX - swiper.touches.startX);
      let scale = 1 + (delta / 1000);
      if (scale > 1.4) scale = 1.4;
      this.rateScale[dir] = scale;
    },

    keyListener(e) {
      if (e.keyCode === 37) {
        // left
        this.voteFor(100);
      } else if (e.keyCode === 39) {
        // right
        this.voteFor(500);
      }
    },

    waitNewImage() {
      const img = new Image();
      setTimeout(() => {
        this.imageLoaded = true;
        img.onload = () => {
          setTimeout(() => {
            this.$store.commit(types.VOTE_BUSY, false);
            setTimeout(() => {
              this.imageLoaded = false;
            }, 400);
          }, 300);
        };
        if (this.refs.results && this.refs.results[this.slide]) {
          img.src = this.refs.results[this.slide].image;
        }
      }, 300);
    },

    voteFor(val) {
      this.$store.commit(types.VOTE_BUSY, true);
      this.$store.commit(types.TEMP_REF, {
        ref: this.refs.results[this.voteCounter],
        value: val,
      });
      setTimeout(() => {
        this.$store.commit(types.VOTE_COUNTER, val);
        if (this.voteCounter >= this.refs.results.length) {
          this.$store.dispatch('voteRefs');
          this.$store.dispatch('updateFacebookOpenGraph', this.person.id);
          this.$router.push(`/accounts/${this.person.id}/`);
        }
      }, 500);
    },

    showHint() {
      this.hint = true;
      setTimeout(() => {
        this.hint = false;
      }, 6000);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@keyframes hideImage {
  from{
    transform: scale(1);
    opacity: 1;
  }
  to{
    transform: scale(.8);
    opacity: 0;
  }
}

@keyframes showImage {
  from{
    transform: scale(.8);
    opacity: 0;
  }
  to{
    transform: scale(1);
    opacity: 1;
  }
}

.rate{
  &--wrap{
    overflow: hidden;
    max-width: 95vw;
    padding: 0 50px;
    margin: 50px auto 0;
    width: 90%;
  }
  &--image{
    animation: showImage .5s ease-in-out;
    transition: all .3s ease-in-out;
    transform-origin: top center;
    img{
      padding-bottom: 50px;
      pointer-events: none;
      user-select: none;
      max-width: 100%;
      display: block;
      margin: 0 auto;
      height: auto;
    }

    &-busy{
      animation: hideImage .3s ease-in-out;
      transition: all .3s ease-in-out;
      opacity: 0;
    }
  }

  &--hint{
    
    transform: translate3d(-50%,500px,0);
    transition: all 1s ease-in-out;
    padding: 13px 10px 0;
    border-radius: 25px;
    background: #cccccc;
    text-align: center;
    visibility: hidden;
    position: fixed;
    font-size: 80%;
    color: black;
    z-index: 999;
    width: 230px;
    bottom: 20px;
    opacity: 0;
    left: 50%;

    &-active{
      transform: translate3d(-50%,0,0);
      visibility: visible;
      opacity: 1;
    }

    @media (max-width: $mediaIpad) {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Rate.vue?6c831a9a